module.exports = {"body":"<p>Custom cabinetry and woodwork not only improves the look of your home but can also\nincrease the over all value too. Upgrading cabinets, doors, trim work and shelving can\nbe a relatively noninvasive and quick way to enhance the interior of your house.</p>\n<p>From custom built in cabinets, to wainscoting and crown molding, Enhanced Interiors Remodeling will work for you.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./work/Woodwork.md
// module id = 518
// module chunks = 0